module.exports = __webpack_public_path__ + "img/speed.78302a41.jpg";